import { SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CustomConfirmationModal
} from '../../../../../UiComponentsLibrary/CustomConfirmationModal';
import { IMPContextualNodeData, PreviousNodesValues } from '../../interface/DetailedBookingInterface';

interface StatusModalProps {
  title: string;
  message: string;
  showErrorModal: boolean;
  setShowErrorModal: (show: boolean) => void;
  errorNodeId: string;
  setErrorNodeId: (id: string) => void;
  setContextualNodes: (value: SetStateAction<IMPContextualNodeData[]>) => void;
  isEditMode: boolean;
  previousNodeValues: PreviousNodesValues | null;
  setPreviousNodeValues: (value: PreviousNodesValues | null) => void;
}

const StatusModal = ({
  title,
  message,
  showErrorModal,
  setShowErrorModal,
  errorNodeId,
  setErrorNodeId,
  setContextualNodes,
  isEditMode,
  previousNodeValues,
  setPreviousNodeValues,
}: StatusModalProps) => {
  const { t } = useTranslation();

  const restoredValues = isEditMode && previousNodeValues
    ? previousNodeValues
    : { valueToBeLockedAtPackageLevel: 0, impressions: 0, approxShareBlockedOverNode: 0 };

  const handleStatusModal = () => {
    setContextualNodes((prev) =>
      prev.map((node) => node.id === errorNodeId ? { ...node, ...restoredValues } : node)
    );
    setShowErrorModal(false);
    setErrorNodeId('');
    setPreviousNodeValues(null);
  };

  return (
    <CustomConfirmationModal
      isOpen={showErrorModal}
      title={title}
      message={message}
      confirmButtonText={t('ok-button')}
      onConfirmCb={handleStatusModal}
      onCancelCb={handleStatusModal}
      confirmButtonDisabled={false}
    />
  );
};

export default StatusModal;